import * as React from 'react';
import clsx from 'clsx';

import { Typography } from 'omakase';

type IconComponent = React.ComponentType<{ className?: string }>;

type OfferingDetailSummaryRowProps = React.PropsWithChildren<{
  icon: IconComponent;
  alignTop?: boolean;
  'data-testid'?: string;
}>;

const ICON_CLASS_NAME = 'EventDetailSummary-icon';

export function OfferingDetailSummaryRow({
  icon: Icon,
  alignTop,
  'data-testid': dataTestId,
  children,
}: OfferingDetailSummaryRowProps) {
  return (
    <div
      className={clsx('EventDetailSummary-item', {
        'EventDetailSummary-item--alignTop': alignTop,
      })}
      data-testid={dataTestId}
    >
      <Icon className={ICON_CLASS_NAME} />
      <Typography variant="body02" component="span">
        {children}
      </Typography>
    </div>
  );
}
